module.exports = __webpack_public_path__ + "static/img/footer_componay_01_zh.03585cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_componay_01_zh.png
// module id = eRJQ
// module chunks = 34